import ProfileLayout from '../modules/Profile/ProfileLayout';
import { Receipts } from '../modules/Profile/Receipts';
import { CustomNextPage } from '../lib/types';
import { profilePageQuery } from '../core-types';
import { PROFILE_PAGE_QUERY } from '../modules/Profile/graphql';
import { bootstrap } from '../lib/bootstrap';

const ReceiptsPage: CustomNextPage<{
  statusCode?: number;
}> = props => {
  const { url, statusCode } = props;
  return (
    <ProfileLayout statusCode={statusCode} url={url}>
      {() => {
        return <Receipts />;
      }}
    </ProfileLayout>
  );
};

ReceiptsPage.getInitialProps = async ctx => {
  const profilePageQueryResult = await ctx.apolloClient.query<profilePageQuery>(
    {
      query: PROFILE_PAGE_QUERY
    }
  );
  let statusCode;
  if (!profilePageQueryResult.data?.profilePage) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return {
    statusCode
  };
};

export default bootstrap(ReceiptsPage);
